var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankDeposit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bank_deposit_svg__clip0_4624_93979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 27.167H8v2.666H5.332v-2.666H3.999a1.333 1.333 0 01-1.333-1.334v-20A1.333 1.333 0 013.999 4.5h24a1.334 1.334 0 011.334 1.333v20a1.333 1.333 0 01-1.334 1.334h-1.333v2.666h-2.667v-2.666zM5.332 24.5h21.333V7.167H5.333V24.5zm12-5.501v4.168h-2.667v-4.168A5.336 5.336 0 0115.999 8.5a5.333 5.333 0 011.334 10.499zM15.999 16.5a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334z",
    fill: "#F8FAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bank_deposit_svg__clip0_4624_93979"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h32v32H0z"
  })))));
}
export default SvgBankDeposit;